import { useDispatch } from "react-redux"
import { useEffect, useMemo } from "react"
import { getJobToReview } from "../Actions/API/Job/JobActions"
import { useAppState } from "./useReduxState"
import { findValue } from "../Models/Client/RemoteData"
import { FetchState, hasValue, isStale } from "../Models/Client/FetchState"
import { isToBeReviewed, JobIDReviewModel } from "../Models/API/JobModel"
import { Result } from "../Models/Utility/Result"
import { useAssumedRoles } from "./useAssumedRoles"

export function useJobIdToReview(
    appID: string
): FetchState<JobIDReviewModel | "nothing_to_review"> {
    const dispatch = useDispatch()
    const jobIDFetch = useAppState(state => state.api.jobs.jobIdToReview[appID])
    const fallbackJobID: string | undefined = useAppState(state => {
        if (hasValue(jobIDFetch)) {
            return undefined
        }

        const fallback = findValue(state.api.jobs.table[appID], isToBeReviewed)

        return fallback?.id
    })
    const rolesFetch = useAssumedRoles(appID)

    useEffect(() => {
        if (
            (jobIDFetch !== undefined && !isStale(jobIDFetch)) ||
            !hasValue(rolesFetch)
        ) {
            return
        }

        dispatch(getJobToReview(appID))
    }, [dispatch, jobIDFetch, appID, rolesFetch])

    return useMemo(
        () =>
            hasValue(jobIDFetch)
                ? jobIDFetch
                : fallbackJobID
                ? Result.ok({ jobId: fallbackJobID, total: 1 })
                : undefined,
        [fallbackJobID, jobIDFetch]
    )
}
